import {
  FormControl,
  FormLabel,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import { InputWrapper, LabelStyle } from "../../styles/form";

type Props = {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  showLabel?: boolean;
};

const TextFilterField = ({
  label,
  value,
  onChange,
  placeholder,
  showLabel = true,
}: Props) => {
  return (
    <FormControl sx={{ ...InputWrapper, width: "100%" }}>
      {showLabel && label && <FormLabel sx={LabelStyle}>{label}</FormLabel>}
      <TextField
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder ?? (label ? `Enter ${label.toLowerCase()}` : "")}
        InputProps={{
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton onClick={() => onChange("")} size="small">
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
      />
    </FormControl>
  );
};

export default TextFilterField;
